export const tagCategories = {
  tag: "TAG",
  category: "CATEGORY",
};
